export default class ExportTranslationCacheName {
  static getExportTranslation(): string {
    return "exportTranslation";
  }
}
